import { PromotionsApi } from '../clients';

export const updatePromotion = async (promotionId, changes) =>
  PromotionsApi.updatePromotion(promotionId, changes);
